import { Box } from "@mui/material";
import { useAppSelector } from "redux/store";
import logoHeader from "assets/logoHeader.svg";
import { updateStatusBarColor } from "utils/pwa";
import { isAndroid, } from "react-device-detect";
import MenuDrawer from "components/MenuDrawer";
import BackButton from "components/BackButton";


const WelcomeHeader = () => {
  const user = useAppSelector((state) => state.userLoggedState.user);
  const isStandalone = useAppSelector(
    (state) => state.configState.isStandalone
  );



  if (isAndroid && isStandalone) {
    updateStatusBarColor("#000");
  }

  return (
    <>
      {(user) && (
        <Box
          sx={{
            height: isStandalone
              ? "calc(38px + env(safe-area-inset-top))"
              : "95px",
            width: "100%",
            backgroundColor: "#000",
            padding: "0 1rem",
            display: "flex",
            alignItems: "center",
            position: "fixed",
            zIndex: 1201
          }}
        >
          <Box sx={{
            position: "absolute", // Centrado absoluto
            left: "5%",
          }}>
            <BackButton/>
          </Box>

          {/* Logo */}
          <Box sx={{
            position: "absolute", // Centrado absoluto
            left: "50%",
            transform: "translateX(-50%)", // Ajusta la posición para centrarlo
          }}>
            <img
              height={110}
              width={110}
              alt="Logo"
              src={logoHeader}
              style={{ objectFit: "contain" }}
            />

          </Box>
          {/* Menu */}
          <Box sx={{
            position: "absolute", // Centrado absoluto
            right: "0%",
            paddingRight: "1rem",
          }}>
            <MenuDrawer />
          </Box>

        </Box>
      )}
    </>
  );
};

export default WelcomeHeader;
